import { useEventsSubscriber, EventData } from 'event-bus';
import {
  PLAN_TASK_CREATED,
  PLAN_TASK_UPDATED,
  PLAN_TASK_DELETED,
  PlanTaskEvent,
} from 'nekst-api';
import { toastService } from './toastService';

/**
 * Plan Tasks Events Toast Listener
 * Subscribes to plan task events and displays toast notifications
 */
export default function PlanTasksEventsToasts() {
  useEventsSubscriber(
    'PlanTasksEventsToasts',
    {
      [PLAN_TASK_CREATED]: (eventData: EventData) => {
        const event = eventData as PlanTaskEvent;
        toastService.createToast(`Task ${event.name} created`);
      },
      [PLAN_TASK_UPDATED]: (eventData: EventData) => {
        const event = eventData as PlanTaskEvent;
        toastService.createToast(`Task ${event.name} updated`);
      },
      [PLAN_TASK_DELETED]: () => {
        toastService.createToast('Task deleted');
      },
    },
    []
  );

  return null;
}
